import { styled } from "goober";
import { Text } from "./Text";

export const PreviewListBox = styled("div")`
  margin: 0;
  padding: 4px;
  border: 0.5px solid var(--border-alpha);
  border-radius: 12px;
  background: var(--surface-secondary);
  max-height: 160px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const SectionLabel = styled("div")`
  padding: 6px 8px 2px;
`;

export function PreviewSectionLabel({ children }: { children: string }) {
  return (
    <SectionLabel>
      <Text variant="text-small" color="var(--text-secondary)">
        {children}
      </Text>
    </SectionLabel>
  );
}
